<form [formGroup]="detailsForm" (ngSubmit)="onSubmit()" class="user-details-form">
    <!-- ================= PERSONAL DETAILS ================= -->
    <div
        class="form-card"
        [ngClass]="{
            'no-bg': mode === 'recipient-only'
        }"
    >
        <div class="personal" *ngIf="mode !== 'recipient-only'">
            <div class="form-subheader">
                <mat-icon
                    svgIcon="box_user"
                    class="form-subheader-icon"
                    aria-hidden="false"
                    aria-label="User Icon"
                ></mat-icon>
                <h3 class="form-subheading">Personal Details</h3>
            </div>

            <div class="two-columns-grid">
                <div class="form-field-group">
                    <label class="form-field-label" for="name"> Full Name </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="name"
                            formControlName="name"
                            placeholder="Enter your full name"
                            aria-labelledby="name"
                        />
                        <mat-error *ngIf="detailsForm.get('name') | firstError: 'name' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" for="email"> Email Address </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="email"
                            formControlName="email"
                            placeholder="your.email@example.com"
                            aria-labelledby="email"
                            autocomplete="email"
                            appTrimOnBlur
                        />
                        <mat-error *ngIf="detailsForm.get('email') | firstError: 'email' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                @if (!hideAgeAndShowMobile) {
                <div class="form-field-group age-field-group">
                    <label class="form-field-label" for="age"> Age </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="age"
                            formControlName="age"
                            placeholder="Your age"
                            aria-labelledby="age"
                            inputmode="numeric"
                            minlength="1"
                            maxlength="3"
                            (keypress)="allowOnlyNumbers($event)"
                        />
                        <mat-error *ngIf="detailsForm.get('age') | firstError: 'age' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>
                } @else {
                <div class="form-field-group age-field-group">
                    <label class="form-field-label" for="userMobileNumber"> Mobile Number </label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="userMobileNumber"
                            formControlName="userMobileNumber"
                            placeholder="Enter mobile number"
                            aria-labelledby="mobileNumber"
                            inputmode="numeric"
                            minlength="10"
                            maxlength="10"
                            (keypress)="allowOnlyNumbers($event)"
                        />
                        <mat-error
                            *ngIf="detailsForm.get('userMobileNumber') | firstError: 'userMobileNumber' as error"
                        >
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>
                }
            </div>

            <div class="two-columns-grid">
                <div class="form-field-group">
                    <label class="form-field-label" for="houseNumber"> House No. & Floor </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="houseNumber"
                            formControlName="houseNumber"
                            placeholder="e.g., 301, 3rd Floor"
                            aria-labelledby="houseNumber"
                        />
                        <mat-error *ngIf="detailsForm.get('houseNumber') | firstError: 'houseNumber' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" for="pincode"> Pincode </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="pincode"
                            formControlName="pincode"
                            placeholder="Enter 6-digit pincode"
                            aria-labelledby="pincode"
                            inputmode="numeric"
                            maxlength="6"
                            (keypress)="allowOnlyNumbers($event)"
                        />
                        <mat-error *ngIf="detailsForm.get('pincode') | firstError: 'pincode' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group full-row">
                    <label class="form-field-label" for="address"> Full Address </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <textarea
                            matInput
                            id="address"
                            formControlName="address"
                            placeholder="Building name, street, locality"
                            aria-labelledby="address"
                            rows="3"
                            autocomplete="on"
                        ></textarea>
                        <mat-error *ngIf="detailsForm.get('address') | firstError: 'address' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" (click)="openStateSelect()"> State </label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            type="text"
                            matInput
                            #stateTrigger="matAutocompleteTrigger"
                            placeholder="Select State"
                            formControlName="state"
                            [matAutocomplete]="stateAuto"
                        />

                        <mat-autocomplete
                            #stateAuto="matAutocomplete"
                            (optionSelected)="onStateSelected($event.option.value)"
                        >
                            <mat-option *ngFor="let state of filteredStates | async" [value]="state.name">
                                {{ state.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon
                            matSuffix
                            class="custom-arrow-select-icon"
                            [ngClass]="{ open: stateTrigger.panelOpen }"
                            ><span class="material-icons-outlined"> keyboard_arrow_down </span></mat-icon
                        >
                        <mat-error *ngIf="detailsForm.get('state') | firstError: 'state' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" for="city" (click)="openCitySelect()"> City </label>
                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            #cityTrigger="matAutocompleteTrigger"
                            placeholder="Select City"
                            formControlName="city"
                            [matAutocomplete]="cityAuto"
                        />

                        <mat-autocomplete #cityAuto="matAutocomplete">
                            <mat-option *ngFor="let city of filteredCities | async" [value]="city.name">
                                {{ city.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix class="custom-arrow-select-icon" [ngClass]="{ open: cityTrigger.panelOpen }"
                            ><span class="material-icons-outlined"> keyboard_arrow_down </span></mat-icon
                        >
                        <mat-error *ngIf="detailsForm.get('city') | firstError: 'city' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group full-row">
                    <div class="address-type-wrapper">
                        @for (option of addressTypeOptions; track option.type) {
                        <button
                            type="button"
                            class="address-card"
                            [class.selected]="detailsForm.value.addressType === option.type"
                            (click)="detailsForm.get('addressType')?.setValue(option.type)"
                        >
                            <mat-icon
                                svgIcon="{{ option.icon }}"
                                class="address-type-icon"
                                [ngClass]="{ 'location-icon': option.type === AddressType.Other }"
                            ></mat-icon>
                            <span class="label">{{ option.label }}</span>
                            <mat-icon
                                *ngIf="detailsForm.value.addressType === option.type"
                                svgIcon="check"
                                class="check-icon"
                            ></mat-icon>
                        </button>
                        }
                    </div>
                    <mat-error *ngIf="detailsForm.get('addressType') | firstError: 'addressType' as error">
                        {{ error }}
                    </mat-error>
                </div>
            </div>

            <!-- ================= CHECKBOX ================= -->
            <div class="form-field-group">
                <mat-checkbox formControlName="useDifferentRecipientInfo" class="form-field">
                    Use different recipient's information
                </mat-checkbox>
            </div>
        </div>

        <!-- ================= RECIPIENT DETAILS ================= -->

        <div
            class="recipient"
            formGroupName="recipient"
            *ngIf="detailsForm.get('useDifferentRecipientInfo')?.value || mode === 'recipient-only'"
        >
            <div class="form-subheader" *ngIf="mode != 'recipient-only'">
                <mat-icon
                    svgIcon="box_user"
                    class="form-subheader-icon"
                    aria-hidden="false"
                    aria-label="User Icon"
                ></mat-icon>
                <h3 class="form-subheading">Recipient's Details</h3>
            </div>

            <div class="two-columns-grid">
                <div class="form-field-group">
                    <label class="form-field-label" for="recipient-name"> Full Name </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="recipient-name"
                            formControlName="name"
                            placeholder="Enter full name"
                            aria-labelledby="recipient-name"
                        />
                        <mat-error *ngIf="detailsForm.get('recipient.name') | firstError: 'name' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" for="recipient-mobileNumber"> Mobile Number </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="recipient-mobileNumber"
                            formControlName="mobileNumber"
                            placeholder="Enter mobile number"
                            aria-labelledby="recipient-mobileNumber"
                            inputmode="numeric"
                            minlength="10"
                            maxlength="10"
                            (keypress)="allowOnlyNumbers($event)"
                        />
                        <mat-error
                            *ngIf="detailsForm.get('recipient.mobileNumber') | firstError: 'mobileNumber' as error"
                        >
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="two-columns-grid">
                <div class="form-field-group">
                    <label class="form-field-label" for="recipient-houseNumber"> House No. & Floor </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="recipient-houseNumber"
                            formControlName="houseNumber"
                            placeholder="e.g., 301, 3rd Floor"
                            aria-labelledby="houseNumber"
                        />
                        <mat-error
                            *ngIf="detailsForm.get('recipient.houseNumber') | firstError: 'houseNumber' as error"
                        >
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" for="recipient-pincode"> Pincode </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            id="recipient-pincode"
                            formControlName="pincode"
                            placeholder="Enter 6-digit pincode"
                            aria-labelledby="pincode"
                            inputmode="numeric"
                            maxlength="6"
                            (keypress)="allowOnlyNumbers($event)"
                        />
                        <mat-error *ngIf="detailsForm.get('recipient.pincode') | firstError: 'pincode' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group full-row">
                    <label class="form-field-label" for="recipient-address"> Full Address </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <textarea
                            matInput
                            id="recipient-address"
                            formControlName="address"
                            placeholder="Building name, street, locality"
                            aria-labelledby="address"
                            rows="3"
                        ></textarea>
                        <mat-error *ngIf="detailsForm.get('recipient.address') | firstError: 'address' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" (click)="openStateSelect(true)"> State </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            type="text"
                            matInput
                            #recipientStateTrigger="matAutocompleteTrigger"
                            placeholder="Select State"
                            formControlName="state"
                            [matAutocomplete]="stateAuto"
                        />

                        <mat-autocomplete
                            #stateAuto="matAutocomplete"
                            (optionSelected)="onStateSelected($event.option.value)"
                        >
                            <mat-option *ngFor="let state of filteredStates | async" [value]="state.name">
                                {{ state.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon
                            matSuffix
                            class="custom-arrow-select-icon"
                            [ngClass]="{ open: recipientStateTrigger.panelOpen }"
                            ><span class="material-icons-outlined"> keyboard_arrow_down </span></mat-icon
                        >
                        <mat-error *ngIf="detailsForm.get('recipient.state') | firstError: 'state' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="form-field-label" for="recipient-city" (click)="openCitySelect(true)"> City </label>

                    <mat-form-field appearance="outline" class="form-field">
                        <input
                            matInput
                            #recipientCityTrigger="matAutocompleteTrigger"
                            placeholder="Select City"
                            formControlName="city"
                            [matAutocomplete]="cityAuto"
                        />

                        <mat-autocomplete #cityAuto="matAutocomplete">
                            <mat-option *ngFor="let city of filteredCities | async" [value]="city.name">
                                {{ city.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon
                            matSuffix
                            class="custom-arrow-select-icon"
                            [ngClass]="{ open: recipientCityTrigger.panelOpen }"
                            ><span class="material-icons-outlined"> keyboard_arrow_down </span></mat-icon
                        >
                        <mat-error *ngIf="detailsForm.get('recipient.city') | firstError: 'city' as error">
                            {{ error }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-field-group full-row">
                    <div class="address-type-wrapper">
                        @for (option of addressTypeOptions; track option.type) {
                        <button
                            type="button"
                            class="recipient-address-card"
                            [class.selected]="detailsForm.get('recipient.addressType')?.value === option.type"
                            (click)="detailsForm.get('recipient.addressType')?.setValue(option.type)"
                        >
                            <mat-icon
                                svgIcon="{{ option.icon }}"
                                class="address-type-icon"
                                [ngClass]="{ 'location-icon': option.type === AddressType.Other }"
                            ></mat-icon>
                            <span class="label">{{ option.label }}</span>
                            <mat-icon
                                *ngIf="detailsForm.get('recipient.addressType')?.value === option.type"
                                svgIcon="check"
                                class="check-icon"
                            ></mat-icon>
                        </button>
                        }
                    </div>
                    <mat-error *ngIf="detailsForm.get('recipient.addressType') | firstError: 'addressType' as error">
                        {{ error }}
                    </mat-error>
                </div>

                @if (showDefaultAddress) {
                <div class="form-field-group">
                    <mat-checkbox class="form-field" formControlName="isDefault" (change)="toggleDefault($event)">
                        Mark this as my default address
                    </mat-checkbox>
                </div>
                }
            </div>
        </div>
    </div>

    <!-- ================= ACTIONS ================= -->
    @if (showActionButtons) {
    <div class="buttons-container">
        <button mat-button type="button" class="skip-link" (click)="onSkip()">
            <div class="icon-text-wrappper">
                <span>Skip for now</span>
                <mat-icon svgIcon="right_arrow_alt" class="skip-link-icon"></mat-icon>
            </div>
        </button>
        <button
            mat-flat-button
            color="primary"
            class="btn-primary-gradient"
            type="submit"
            [disabled]="detailsForm.invalid"
        >
            <div class="text-icon-wrapper">
                <span>Save & Continue</span>
                <mat-icon svgIcon="check" class="btn-icon"></mat-icon>
            </div>
        </button>
    </div>
    }
</form>
